var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style)},[_vm._t("default",null,{"contentHeight":_vm.contentHeight}),_c('div',{staticClass:"dummy"},[_vm._t("default",null,{"contentHeight":-1})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }